    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">
                        <el-form-item label="秒杀最大购买数量:">
                            <el-input-number v-model="table.where.spike_buy_max" placeholder="请输入秒杀最大购买数量"
                                :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="秒杀价格:">
                            <el-input-number v-model="table.where.spike_price" controls-position="right" :min="0"
                                :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入秒杀价格"
                                clearable />
                        </el-form-item>


                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:storediscountgoods:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:storediscountgoods:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:storediscountgoods:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                            <el-table-column prop="user_id" label="折上折商品" show-overflow-tooltip min-width="250">
                                <template slot-scope="{row}">
                                    <el-tag v-for="(item,index) in row.goods_id_info" :key="index">{{item.name}}
                                    </el-tag>
                                </template>
                            </el-table-column>
                        <el-table-column prop="spike_buy_max" label="秒杀最大购买数量" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="spike_price" label="秒杀价格" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:storediscountgoods:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此折上折商品信息吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:storediscountgoods:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改折上折商品信息':'添加折上折商品信息'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                    <el-form-item label="折上折商品:" prop="goods_id">
                        <el-select v-model="editForm.goods_id" filterable placeholder="请选择规格" @change="changeGoods">
                            <el-option v-for="(item,index) in store_goods_list" :key="index" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-table ref="multipleTable" :data="tableColumnList.tableBodyList" stripe tooltip-effect="dark"
                            style="width: 100%;margin-top:1%;" border>
                            <el-table-column :label="item.propName" :property="item.prop"
                                v-for="item in tableColumnList.tableHeaderList" :key="item.prop" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[scope.column.property] }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_price" label="销售价">
                                <template slot-scope="{row}">
                                    <el-input type="number" :disabled="true" v-model="row.price" placeholder="输入价格"></el-input>
                                </template>
                            </el-table-column>
                           <el-table-column prop="sku_price" label="折上折价格">
                               <template slot-scope="{row}">
                                   <el-input type="number" v-model="row.sku_price" placeholder="输入库存"></el-input>
                               </template>
                           </el-table-column>
                            <el-table-column prop="sku_stock" label="折上折库存">
                                <template slot-scope="{row}">
                                    <el-input type="number" v-model="row.sku_stock" placeholder="输入库存"></el-input>
                                </template>
                            </el-table-column>
                            
                        </el-table>
                    </el-form-item>
                    <el-form-item label="折上折最大购买数量:" prop="spike_buy_max">
                        <el-input-number v-model="editForm.spike_buy_max" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入折上折最大购买数量" clearable />
                    </el-form-item>
                    <el-form-item label="销售价:" prop="spike_price">
                        <el-input-number v-model="goods_info.price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入销售价"
                            clearable  :disabled="true"/>
                    </el-form-item>
                    <el-form-item label="折上折价格:" prop="spike_price">
                        <el-input-number v-model="editForm.spike_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left" placeholder="请输入折上折价格"
                            clearable />
                    </el-form-item>
                    <el-form-item label="折扣备注:" prop="spike_desc">
                        <el-input v-model="editForm.spike_desc"  class="ele-fluid ele-text-left" placeholder="请输入折扣备注"
                            clearable />
                    </el-form-item>

                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";
        export default {
            name: "SysStoreDiscountGoods",
            components: {},
            data() {
                return {
                    goods_info:{},
                    tableColumnList:{},
                    table: {
                        url: '/store/StoreDiscountGoods/index',
                        where: {}
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {}, // 表单数据
                    editFormTemp: {},
                    admin_list: [],
                    user_list: [],
                    store_goods_list:[],
                    search_show: false,
                    editRules: { // 表单验证规则

                        term_id: [{
                            required: true,
                            message: '请选择关联秒杀期数id',
                            trigger: 'blur'
                        }],


                        goods_id: [{
                            required: true,
                            message: '请选择商品',
                            trigger: 'blur'
                        }],


                        spike_buy_max: [{
                            required: true,
                            message: '请输入秒杀最大购买数量',
                            trigger: 'blur'
                        }],


                        spike_price: [{
                            required: true,
                            message: '请输入秒杀价格',
                            trigger: 'blur'
                        }],


                        spike_desc: [{
                            required: true,
                            message: '请输入折扣备注',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {
                this.StoreGoodsAllList();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/store/StoreDiscountGoods/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                                this.StoreGoodsgetActivityList(this.editForm.goods_id);
                                this.goodsInfo(this.editForm.goods_id);
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.editForm.tableBodyList = this.tableColumnList.tableBodyList;
                            this.$http.post('/store/StoreDiscountGoods/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的折上折商品信息吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/store/StoreDiscountGoods/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/store/StoreDiscountGoods/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/store/StoreDiscountGoods/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },
                //查询其他信息
                StoreGoodsAllList() {
                    this.$http.post('/store/StoreGoods/allList', {activity_status: 0}).then(res => {
                        if (res.data.code === 0) {
                            this.store_goods_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                StoreGoodsgetActivityList(id) {
                    this.$http.post('/store/StoreGoods/getActivityList', {id: id}).then(res => {
                        if (res.data.code === 0) {
                            this.store_goods_list = res.data.data;
                            this.$forceUpdate();
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                goodsInfo(e){
                   this.$http.post('/store/StoreGoods/info', {id:e}).then(res => {
                       if (res.data.code === 0) {
                           this.goods_info = res.data.data;
                          this.editForm.tableColumnList = this.goods_info.tableColumnList;
                          this.tableColumnList = {};
                           if (this.editForm.tableColumnList) {
                               this.editForm.tableColumnList.status = true;
                               this.tableColumnList = this.editForm.tableColumnList || [];
                               for(var i = 0;i<this.tableColumnList.tableBodyList.length;i++){
                                   this.tableColumnList.tableBodyList[i].price = this.tableColumnList.tableBodyList[i].sku_price;
                                   this.tableColumnList.tableBodyList[i].sku_price = '';
                                   this.tableColumnList.tableBodyList[i].sku_stock = '';
                                   if(this.editForm.format){
                                       for (var j = 0; j < this.editForm.format.length; j++) {
                                           if (this.tableColumnList.tableBodyList[i].sku_id == this.editForm.format[j].sku_class_id) {
                                              this.tableColumnList.tableBodyList[i].sku_price =this.editForm.format[j].sku_price;
                                              this.tableColumnList.tableBodyList[i].sku_stock = this.editForm.format[j].sku_stock;
                                           }
                                       }
                                   }
                               }
                           }
                       } else {
                           this.$message.error(res.data.msg);
                       }
                   }).catch(e => {
                       this.$message.error(e.message);
                   });
                },
                changeGoods(e){
                   this.$http.post('/store/StoreGoods/info', {id:e}).then(res => {
                       if (res.data.code === 0) {
                           this.goods_info = res.data.data;
                          this.editForm.tableColumnList = this.goods_info.tableColumnList;
                          this.tableColumnList = {};
                           if (this.editForm.tableColumnList) {
                               this.editForm.tableColumnList.status = true;
                               this.tableColumnList = this.editForm.tableColumnList || [];
                               for(var i = 0;i<this.tableColumnList.tableBodyList.length;i++){
                                   this.tableColumnList.tableBodyList[i].price = this.tableColumnList.tableBodyList[i].sku_price;
                                   this.tableColumnList.tableBodyList[i].sku_price = '';
                                   this.tableColumnList.tableBodyList[i].sku_stock = '';
                               }
                               
                               console.log(this.tableColumnList)
                           }
                       } else {
                           this.$message.error(res.data.msg);
                       }
                   }).catch(e => {
                       this.$message.error(e.message);
                   });
                },

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>